<script setup lang="ts">
import { computed } from 'vue'
import { usePrevioDS } from '../../composables/helpers'
import { PSpaceSize } from '../space/types'
import PToast from '../toast/PToast.vue'
import { type Toast } from '../../composables/helpers/toasts'
import type { HideProps } from './PSnackbar.vue'
import PSpace from './../space/PSpace.vue'

const ds = usePrevioDS()

const onSnackBarHidden = (data: HideProps): void => {
  ds.toast.hide(data.id)
}

const toasts = computed<Toast[]>(() => {
  if (ds.screen().isMobile) {
    return [...ds.toast.toasts].reverse()
  } else {
    return ds.toast.toasts
  }
})
</script>

<template>
  <div class="ds-notifications-wrapper z-top">
    <transition-group name="list">
      <div v-for="toastEntity in toasts" :key="toastEntity.id">
        <p-space :mobile="PSpaceSize.SM" vertical />
        <p-toast
          :title="toastEntity.message"
          :variant="toastEntity.type"
          :timeout="toastEntity.timeout"
          @close="onSnackBarHidden({ id: toastEntity.id })"
        />
      </div>
    </transition-group>
  </div>
</template>

<style scoped lang="scss">
@import '../../assets/scss/shared/variables/ds.spacing';
@import '../../assets/scss/shared/mixins';

.ds-notifications-wrapper {
  position: fixed;
  bottom: calc(#{$space-lg-laptop} + var(--p-safe-area-bottom));
  left: calc(#{$space-lg-laptop} + var(--p-safe-area-left));

  @include mobile {
    top: calc(#{$space-md-mobile} + var(--p-safe-area-top));
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    height: max-content;
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.2s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);

  @include mobile {
    transform: translateY(-30px);
  }
}
</style>
